import { FC } from "react";

import { Image, Grid, Paragraph, Card } from "capitalrx-components-2.0";

import cardStyles from "./cardSectionStyles.module.scss";

import ImagePiggybank from "@/static/images/piggybank.svg?url";
import ImageCoin from "@/static/images/coin.svg?url";
import ImageData from "@/static/images/data.svg?url";

const BetterRXCards: FC = () => {
  return (
    <div className={cardStyles.sectionContainer}>
      <Grid container centered justifyContent="center" className={cardStyles.cardStyleWrapper}>
        <Grid item colLg={4} className={cardStyles.items}>
          <Card className={cardStyles.itemWrapper} testId="card-piggybank">
            <Image src={ImagePiggybank} alt="piggybank" ariaHidden="true" />
            <Paragraph className={cardStyles.text}>Get consistent, low pricing every visit</Paragraph>
          </Card>
        </Grid>
        <Grid item colLg={4} className={cardStyles.items}>
          <Card className={cardStyles.itemWrapper} testId="card-coin">
            <Image src={ImageCoin} alt="coin" ariaHidden="true" />
            <Paragraph className={cardStyles.text}>Stop paying hidden fees (~$7 / script)</Paragraph>
          </Card>
        </Grid>
        <Grid item colLg={4} className={cardStyles.items}>
          <Card className={cardStyles.itemWrapper} testId="card-data">
            <Image src={ImageData} alt="data" ariaHidden="true" />
            <Paragraph className={cardStyles.text}>We never sell your data to 3rd parties</Paragraph>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default BetterRXCards;
